import React from "react";
import { graphql, useFragment } from "react-relay";

import { StarButton as _StarButton } from "~/ui/legacyFellowIndex";

import { starNoteTemplate, unstarNoteTemplate } from "./noteTemplateGql";

import type { StarButtonNoteTemplate$key } from "~/__generated__/StarButtonNoteTemplate.graphql";

export function SmartStarButton({
	template: templateKey,
	className,
}: {
	template: StarButtonNoteTemplate$key;
	className?: string;
}) {
	const template = useFragment(
		graphql`
			fragment StarButtonNoteTemplate on NoteTemplateNode {
				id
				starred
			}
		`,
		templateKey,
	);

	return <StarButton id={template.id} starred={template.starred} className={className} />;
}

export function StarButton({ id, starred, className }: { id: string; starred: boolean; className?: string }) {
	const onStar = React.useCallback(
		(e: React.MouseEvent) => {
			e.stopPropagation();
			return starred ? unstarNoteTemplate(id) : starNoteTemplate(id);
		},
		[id, starred],
	);

	return <_StarButton selected={starred} onClick={onStar} className={className} />;
}
